module.exports = __webpack_public_path__ + "img/Oximeter.acea71da.png";